import React from "react";
import { getDate } from "../../../../../assets/js/date-time-converter";

const OrderOverviewPersonalDetails = (props) => {
  if (!props) {
    return null;
  }

  const {
    sectors,
    countries,
    genders,
    customerData,
    hasModuleScheduler,
    textsMapping,
    goToStep,
  } = props;

  let selectedGender = genders.find(
    (obj) => obj.value === customerData.personalDetails.salutation
  );
  let selectedCountry = countries.find(
    (obj) => obj.value === customerData.address.country
  );
  let selectedSector = sectors.find(
    (obj) => obj.value === customerData.personalDetails.sector
  );

  return (
    <section className="checkout-section order-summary__personal-details">
      <div className="checkout-section__header">
        <div className="checkout-section__header-text">
          <h3 className="checkout-section__title">
            {textsMapping.orderOverviewPersonalDetailsTitle}
          </h3>
          <p>{textsMapping.orderOverviewPersonalDetailsText}</p>
        </div>
        <button
          type="button"
          onClick={() => goToStep("jump", hasModuleScheduler ? 1 : 0)}
          className="checkout-section__edit-link nev-icon nev-icon-pencil"
        >
          <span className="checkout-section__edit-link-text">
            {textsMapping.editLinkText}
          </span>
        </button>
      </div>

      <dl>
        <dt>{textsMapping.orderOverviewPersonalDetailsName}</dt>
        <dd>
          {customerData.personalDetails.salutation !== "X"
            ? selectedGender !== undefined
              ? selectedGender.name
              : null
            : null}{" "}
          {customerData.personalDetails.initials}{" "}
          {customerData.personalDetails.insertion}{" "}
          {customerData.personalDetails.lastName}
        </dd>

        <dt>{textsMapping.orderOverviewPersonalDetailsDateOfBirth}</dt>
        <dd>
          {getDate(customerData.personalDetails.dateOfBirth, true, false)}
        </dd>

        <dt>{textsMapping.orderOverviewPersonalDetailsSector}</dt>
        <dd>{selectedSector !== undefined ? selectedSector.name : null}</dd>

        <dt>{textsMapping.orderOverviewPersonalDetailsFunctionTitle}</dt>
        <dd>{customerData.personalDetails.functionTitle}</dd>

        <dt>{textsMapping.orderOverviewPersonalDetailsMail}</dt>
        <dd>{customerData.accountDetails.email}</dd>

        {customerData.personalDetails.phoneNumber !== "" ? (
          <dt>{textsMapping.orderOverviewPersonalDetailsPhone}</dt>
        ) : null}
        {customerData.personalDetails.phoneNumber !== "" ? (
          <dd>{customerData.personalDetails.phoneNumber}</dd>
        ) : null}

        <dt>{textsMapping.orderOverviewPersonalDetailsHomeAddress}</dt>
        <dd>
          {customerData.address.street} {customerData.address.houseNumber}{" "}
          {customerData.address.houseNumberAddition}
          <br />
          {customerData.address.zip}, {customerData.address.city}
          <br />
          {!customerData.address.defaultCountry && selectedCountry !== undefined
            ? selectedCountry.name
            : null}
        </dd>
      </dl>
    </section>
  );
};

export default OrderOverviewPersonalDetails;
